<template>
  <div class="main_center">
    <div class="content">
      <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
        <div class="search-drawer">
          <el-form :model="form" label-position="top" ref="form">
            <el-form-item label="抽取编号：" props="extractCode">
              <el-input clearable placeholder="请输入内容搜索" v-model="form.extractCode"></el-input>
            </el-form-item>
            <el-form-item label="任务名称：" props="workName">
              <el-input clearable placeholder="请输入内容搜索" v-model="form.workName"></el-input>
            </el-form-item>
            <el-form-item label="抽取状态：" props="witnessMod">
              <el-select clearable style="width:100%;" v-model="form.historyid" value-key="value">
                <el-option label="全部" value="-99"></el-option>
                <el-option label="未完成" value="-1"></el-option>
                <el-option label="已完成" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="抽取方式：" props="type">
              <el-select clearable style="width:100%;" v-model="form.type" value-key="value">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="双随机抽取" value="1"></el-option>
                <el-option label="定向抽取" value="2"></el-option>
              </el-select>
            </el-form-item>
           
            <el-form-item label="抽取完成时间：">
              <el-date-picker
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                style="width: 100%"
                type="datetimerange"
                v-model="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="数据所属部门：">
                <select-depart-tree 
                ref="selectDepartTreeRef"
                :type="'2'"
                :modelValue.sync="form.superviseDeptCodeList"  
                :isMultiple="true" 
                @handleDeptType="(val)=>changeDept(val,'5')" >
                </select-depart-tree>
            </el-form-item>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
            <el-button @click="refresh" plain size="small">重置</el-button>
          </div>
        </div>
      </searchBox>

      <div class="search-content">
        <div class="mainBtn">
          <el-button
            @click="routerDetail('','detail')"
            size="small"
            type="primary"
            v-if="hasBtnPermission('supervise_double_extract_btn_add')"
          >双随机抽取</el-button>
          <el-button
            @click="routerDetail('','dingxiang')"
            size="small"
            v-if="hasBtnPermission('supervise_double_extract_btn_add2')"
          >定向选取</el-button>
        </div>
        <div class="searchBtn">
          <span class="label-form">抽取编号：</span>
          <el-input
            @keyup.enter.native="searchBtn"
            clearable
            placeholder="请输入内容搜索"
            style="width: 200px"
            v-model="form.extractCode"
          ></el-input>
          <span class="label-form">任务名称：</span>
          <el-input
            @keyup.enter.native="searchBtn"
            clearable
            placeholder="请输入内容搜索"
            style="width: 200px"
            v-model="form.workName"
          ></el-input>
          <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
          <el-button
            @click="moreSearchItem = true"
            icon="el-icon-arrow-down"
            size="mini"
            type="text"
          >更多搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>

      <el-table
        :data="tableData"
        class="table-content"
        v-loading="dataListLoading"
        @filter-change="filterChange"
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        ref="multipleTable"
        :height="tableMaxHeight"
        stripe
        border
      >
        <el-table-column
          fixed
          type="index"
          align="center"
          label="序号"
          width="60"
          :index="getRowsIndex"
        ></el-table-column>
        <el-table-column
          label="抽取状态"
          prop="workName"
          align="center"
          width="90px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <i :class="formatterStatusClass(scope.row.historyid)"></i>
            <span>{{scope.row.historyid == 0?'已完成':'未完成'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="抽取编号"
          prop="extractCode"
          header-align="center"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="任务名称"
          prop="workName"
          header-align="left"
          align="left"
          min-width="200"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{scope.row.createTime?formatDate(scope.row.createTime,'yyyy-MM-dd HH:mm'):'---'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="抽取方式"
          :filters="typeNameFilters"
          prop="typeName"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        >
        <template slot-scope="scope">
            <el-tag v-if="scope.row.type==1" type="success">{{scope.row.typeName}}</el-tag>
            <el-tag v-else >{{scope.row.typeName}}</el-tag>
        </template>
        </el-table-column>
        <el-table-column
          label="抽取完成时间"
          prop="extractTime"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{scope.row.extractTime?formatDate(scope.row.extractTime,'yyyy-MM-dd'):'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="抽取类型"
          prop="extractTypeName"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="抽取数量"
          prop="extractNum"
          width="80"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{scope.row.extractNum + '个' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="抽取人"
          prop="extractorName"
          header-align="center"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="执法检查结果"
          prop="importantPrj"
          header-align="center"
          align="center"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.enteredNum==0"><el-tag type="danger">未录入</el-tag></template>
            <template v-else-if="scope.row.enteredNum==scope.row.extractNum"> <el-tag type="success">已全部录入</el-tag></template>
            <template v-else> <el-tag >录入{{scope.row.enteredNum}}/{{scope.row.extractNum}} </el-tag></template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="left" width="250">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="routerDetail(scope.row,(scope.row.type==2?'dingxiang':'detail'))"
              v-if="hasBtnPermission('supervise_double_extract_btn_view')"
            >查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="routerDetail(scope.row,'delete')"
              v-if="scope.row.historyid !== 0&& hasBtnPermission('supervise_double_extract_btn_delete')"
            >删除</el-button>

            <el-button
              type="text"
              v-if="scope.row.historyid == 0&&hasBtnPermission('supervise_double_extract_btn_check_result')"
              size="small"
              title="录入抽查结果"
              @click="routerDetail(scope.row,'list')"
            >录入抽查结果</el-button>
            <el-button
              type="text"
              v-if="hasBtnPermission('supervise_double_extract_btn_publish_result')&&scope.row.historyid == 0 && scope.row.noticeId &&scope.row.noticeHistory!=0"
              size="small"
              title="发布检查结果"
              @click="routerDetail(scope.row,'notice')"
            >发布检查结果</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :page-sizes="[pageSize, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        :current-page="pageIndex"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import selectDepartTree from "@/views/modules/components/selectDepartTree"
import {mapState} from "vuex";
export default {
  name: "busWitnessTable",
  components:{
    selectDepartTree
  },
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 227,
      dataListLoading: false,
      datetimerange: [],
      typeNameFilters: [
        {
          text: "双随机抽取",
          value: "type_1"
        },
        {
          text: "定向抽取",
          value: "type_2"
        }
      ],
      form: {
        extractCode: "",
        workName: "",
        historyid: "-99",
        type: null,
        superviseDeptCodeList:[]
      },
      groupMark: "",
      flownodesListData: [],
      moreSearchItem: false,
      checkList1: "",
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 0, //总条数
      tableData: [],
      multipleSelection: [],
      user: "", //角色类型
      formData: {},
      sortParams: {
        order: "desc",
        prop: "extractTime"
      },
      filters: {
        historyid: "",
        workName: "",
        extractCode: "",
        flowName: "",
        extractTimeGE: "",
        extractTimeLT: "",
        superviseDeptCodeList:[]
      }

    };
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + "...";
      } else {
        return text;
      }
    }
  },
  watch:{
      uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){  this.getDataList() }
        }
    }
    },
  created() {},
  activated() {
    this.getDataList();
  },
  computed:{
		...mapState({
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    }),
    supperAdmin: {
      get() {
        return this.$store.state.user.userinfo.supperAdmin;
      }
    }
	},
  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
    that.ifmove();
  },
  computed: {
    supperAdmin: {
      get() {
        return this.$store.state.user.userinfo.supperAdmin;
      }
    },
    ...mapState({
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
    }),

  },

  methods: {
    changeDept(val,str){//切换部门
        this.form.superviseDeptCodeList=[]
        if(str==='5'){
            // 多选
            val.forEach((item,index)=>{
                if( item.type!=="region"){
                this.form.superviseDeptCodeList.push(item.code)
                }
            })
        }
    },
    filterChange(filters) {
      let filtersParams = {};
      for (var i in filters) {
        var filtersArr = filters[i];
        let key = "",
          value = [];
        filtersArr.length > 0 &&
          filtersArr.forEach(item => {
            key = item.split("_")[0];
            value.push(item.split("_")[1]);
          });
        key && value.length > 0
          ? (filtersParams[key] = value.toString())
          : null;
      }
      filtersParams.historyid =
      this.form.historyid == "-99" ? "" : this.form.historyid;
      filtersParams.workName = this.form.workName;
      filtersParams.extractCode = this.form.extractCode;
      filtersParams.flowName = this.form.flowName;
      filtersParams.extractTimeGE = this.form.extractTimeGE;
      filtersParams.extractTimeLT = this.form.extractTimeLT;
      this.filters = filtersParams;
      this.getDataList();
    },
    dialogCancle() {
      this.moreSearchItem = false;
    },
    formatterStatusClass(historyId) {
      switch (historyId) {
        case 0:
          return "icon-point icon-point-success";
          break;
        case -1:
          return "icon-point icon-point-danger";
          break;
        case 1:
          return "icon-point icon-point-danger";
          break;
        default:
          return "";
          break;
      }
    },

    getRowsIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    ifmove() {
      // let hasBtnPermisson = this.hasBtnPermission("supervise_double_extract_btn_add") || this.hasBtnPermission("supervise_double_extract_btn_add2");
      // let tableMaxHeight = document.documentElement.clientHeight - 297 +  (hasBtnPermisson ? 0 : 33);
      let tableMaxHeight = document.documentElement.clientHeight - 227;
      this.pageSize = parseInt(tableMaxHeight / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
    },
    getDataList() {
         //数据所属部门
        this.filters.superviseDeptCodeList= (this.form.superviseDeptCodeList || []).length==0?this.uerdefultOptionCode:this.form.superviseDeptCodeList
      // 获取列表数据
      this.dataListLoading = true;
      this.form.extractTimeGE = this.datetimerange[0]
        ? this.datetimerange[0]
        : "";
      this.form.extractTimeLT = this.datetimerange[1]
        ? this.datetimerange[1]
        : "";
      this.$httpReq
        .post("/projectDoubleExtract/extracttask/list", {
          page: this.pageIndex,
          rows: this.pageSize,
          orderBy:
          this.sortParams.prop && this.sortParams.order
            ? this.sortParams.prop +
              (this.sortParams.order == "ascending" ? " asc" : " desc")
            : "",
          filter: this.filters
        })
        .then(res => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.$refs.multipleTable.doLayout();
          this.dataListLoading = false;
        });
    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //搜索按钮
    searchBtn() {
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.filters = {
        historyid: this.form.historyid == "-99" ? "" : this.form.historyid,
        workName: this.form.workName,
        extractCode: this.form.extractCode,
        flowName: this.form.flowName,
        extractTimeGE: this.form.extractTimeGE,
        extractTimeLT: this.form.extractTimeLT,
        type: this.form.type,
        tradeId:this.form.tradeId
      };
      this.getDataList();
    },
    refresh() {
      //刷新按钮
      this.moreSearchItem = false;
      this.pageIndex = 1;
      this.datetimerange = [];

      this.form.witnessMod = "-1";
      this.form.witnessStatus = "-1";
      this.form.importantPrj = -1;
      this.form.flowName = "";
      this.form.workName = "";
      this.form.extractCode = "";
      this.form.historyid = "-99";
      this.form.type=null;
      this.form.year = new Date().getFullYear();
      this.form.superviseDeptCodeList = [];
      this.filters = {
        historyid: this.form.historyid == "-99" ? "" : this.form.historyid,
        workName: this.form.workName,
        extractCode: this.form.extractCode,
        flowName: this.form.flowName,
        extractTimeGE: this.form.extractTimeGE,
        extractTimeLT: this.form.extractTimeLT,
        type: this.form.type,
        superviseDeptCodeList:[]
      };
          // 重置默认所属数据
        if( this.$refs.selectDepartTreeRef){
            this.$refs.selectDepartTreeRef.getUserTreeOption()
        }
      this.getDataList();
    },

    routerDetail(item, type) {
      // 跳转详情

      if (type == "detail") {
        // 跳转双随机抽取相关页面
        if (!item || item.historyid != 0) {
          let id = (item && item.id) || "";
          // let routeUrl = this.$router.resolve({
          //     name: "project_extract_detail",
          //     query: {id:id}
          // });
          // window.open(routeUrl.href, '_blank');
          removeTabHandle("project_extract_detail");
          this.$router.push({
            name: "project_extract_detail",
            query: {
              id: id
            }
          });
        } else {
          this.$router.push({
            name: "project_extract_result",
            query: {
              id: item.id
            }
          });
        }
      }
      if (type === "dingxiang") {
        let idval = "";
        let canEdit = "";
        if (item && item.id) {
          idval = item.id;
        }
        if (item.historyid == 0) {
          canEdit = false;
        } else {
          canEdit = true;
        }
        this.$router.push({
          name: "project_direct_extract",
          query: {
            id: idval,
            canEdit
          }
        });
      }
      if (type == "list") {
        // 跳转检查结果录入列表页
        this.$router.push({
          name: "inspectionResultEntry",
          query:{
            code:item.extractCode||'',
            name:item.workName||''
          }
        });
      }
      if (type == "notice") {
        // 跳转录入结果公告页面
        removeTabHandle("resultNotice_detail");
        this.$router.push({
          name: "resultNotice_detail",
          query: {
            id: item.noticeId,
            type: 1
          }
        });
      }
      if (type == "delete") {
        this.$confirm(`确定要删除该数据?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$httpReq
            .post("/projectDoubleExtract/extracttask/delete", {
              id: item.id
            })
            .then(res => {
              if (res.data.code == "1") {
                this.$message({
                  type: "success",
                  message: "数据删除成功！"
                });
                this.getDataList();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            });
        });
      }
    }

    // deleteById(item) {
    //   this.$confirm(`确定要删除该数据?`, "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   }).then(() => {
    //     this.$httpReq
    //       .get(
    //         "/businessFlowWitness/delete?id=" +
    //           item.id +
    //           "&entityId=" +
    //           item.entityId
    //       )
    //       .then(res => {
    //         if (res.data.code == "1") {
    //           this.$message({
    //             type: "success",
    //             message: res.data.msg
    //           });
    //           this.getDataList();
    //         } else {
    //           this.$message({
    //             type: "error",
    //             message: res.data.msg
    //           });
    //         }
    //       });
    //   });
    // },
    // deleteSelectItem() {
    //   let ids = new Array();
    //   let entityIds = new Array();
    //   this.multipleSelection.forEach(key => {
    //     ids.push(key.id), entityIds.push(key.entityId);
    //   });

    //   if (ids != "" || ids.length > 0) {
    //     this.$httpReq
    //       .get(
    //         "/businessFlowWitness/delete?idList=" +
    //           ids +
    //           "&entityIdList=" +
    //           entityIds
    //       )
    //       .then(res => {
    //         if (res.data.code == "1") {
    //           this.$message({
    //             type: "success",
    //             message: res.data.msg
    //           });
    //           this.getDataList();
    //         } else {
    //           this.$message({
    //             type: "error",
    //             message: res.data.msg
    //           });
    //         }
    //       });
    //   } else {
    //     this.$message({
    //       type: "error",
    //       message: "未选择删除项。"
    //     });
    //   }
    // }
  },

  destroyed() {
    window.onresize = null;
  }
};
</script>
<style lang="scss" scoped>
</style>
